<template>
  <LsModal
    title="Recommend on Nextdoor"
    :sub-title="nextdoor.description"
    :track-id="`nextdoor_modal`"
  >
    <template #body>
      <div class="columns nextdoor-modal--bottom-border">
        <div class="column is-1"><div class="nextdoor-modal--number-icon">1</div></div>
        <div class="column is-11">
          <LsInput
            :value="nextdoor.copyMessageWithShortLink"
            :track-id="`nextdoor_modal-share_text`"
            name="share_text"
            type="textarea"
            readonly
          />
          <LsClickable
            :track-id="`nextdoor_modal-copy_share_text`"
            test-id="clickable"
            @click="onCopy"
          >
            <div class="nextdoor-modal--copy-link" test-id="copy">
              <p class="nextdoor-modal--copy-text">COPY MESSAGE</p>
              <LsIcon size="md" type="copy" color="primary" />
            </div>
          </LsClickable>
        </div>
      </div>
      <div class="columns nextdoor-modal--bottom-border">
        <div class="column is-1"><div class="nextdoor-modal--number-icon">2</div></div>
        <div class="nextdoor-modal--button-wrapper column is-11">
          <LsButton
            test-id="share"
            :track-id="`nextdoor_modal-post`"
            name="post"
            :text="getButtonText"
            :bg-color="nextdoor.accentColor"
            :icon="nextdoor.buttonIcon"
            @click="onShare"
          />
        </div>
      </div>

      <div class="columns nextdoor-modal--wrapper">
        <div class="column is-1"><div class="nextdoor-modal--number-icon">3</div></div>
        <div class="column is-11 nextdoor-modal--info-wrapper">
          <LsAdditionalInfo
            :track-id="`nextdoor_modal-heres_how`"
            :label="`Tag ${brandName} as a business so we know you shared!`"
            clickable-label="(Here's how)"
          >
            <img
              alt="How to share"
              class="nextdoor-modal--how-to"
              :src="require(`../../assets/share/${brandPathName}/nextdoor-how-to-tag.png`)"
            />
          </LsAdditionalInfo>
        </div>
      </div>
    </template>
    <template #footer>
      <LsButton test-id="done" text="done" :track-id="`nextdoor_modal-done`" @click="done" />
    </template>
  </LsModal>
</template>

<script>
import {
  LsModal,
  LsButton,
  LsInput,
  LsIcon,
  LsClickable,
  LsAdditionalInfo,
} from '@/components/common';
import { mapActions, mapGetters } from 'vuex';
import { SHARE__SHARE_VIA_PLATFORM, SHARE__PLATFORMS } from '@/store/types';
import { lsDeviceHelpers, lsToastService } from 'ls-vue-common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'NextDoorModal',
  components: {
    LsModal,
    LsButton,
    LsInput,
    LsIcon,
    LsClickable,
    LsAdditionalInfo,
  },
  mixins: [themedComponentMixin],
  computed: {
    ...mapGetters([SHARE__PLATFORMS]),
    nextdoor() {
      return this[SHARE__PLATFORMS].nextdoor;
    },
    getButtonText() {
      return `${lsDeviceHelpers.isMobile() ? 'tap to' : 'click here to'} ${
        this.nextdoor.button_text
      }`;
    },
  },
  methods: {
    ...mapActions([SHARE__SHARE_VIA_PLATFORM]),
    onCopy() {
      this.$copyText(this.nextdoor.copyMessageWithShortLink).then(
        this.onCopySuccess,
        this.onCopyFailure
      );
    },
    onCopySuccess() {
      lsToastService.open({
        message: 'Message copied to clipboard',
        type: 'is-success',
      });
    },
    onCopyFailure() {
      lsToastService.open({ message: 'Unable to copy message', type: 'is-error' });
    },
    onShare() {
      this[SHARE__SHARE_VIA_PLATFORM]({ platform: this.nextdoor });
    },
    done() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  padding: 20px 0;
  margin: 0;
}
.nextdoor-modal--bottom-border {
  border-bottom: 1px solid $primary-light;
}

.columns {
  margin: 0;
}

.nextdoor-modal--button-wrapper {
  display: flex;
  align-items: center;
}
.nextdoor-modal--number-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: $primary;
  color: $white;
  font-size: $size-5;
  font-weight: 700;
}

.nextdoor-modal--copy-link {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.nextdoor-modal--info-wrapper {
  display: flex;
  padding-top: 25px;
}

.nextdoor-modal--copy-text {
  text-transform: uppercase;
  color: $primary;
  font-weight: bold;
  padding-right: 6px;
}

.nextdoor-modal--how-to {
  width: 100%;
}

@media (max-width: $mobile-max-width) {
  .is-1 {
    display: none;
  }
  .nextdoor-modal--info-wrapper {
    display: flex;
    padding-top: 25px;
  }
}

.themed-app {
  .nextdoor-modal--bottom-border {
    border-color: $theme-color-primary-light;
  }
  .nextdoor-modal--number-icon {
    background-color: $theme-color-primary;
    color: $theme-color-white;
    font-size: $theme-txt-body;
  }

  .nextdoor-modal--copy-text {
    color: $theme-color-primary;
  }
}
</style>
